import { ExternalLink } from "lucide-react";

const timeAgo = (iso) => {
        if (!iso) return "—";
        const d = new Date(iso);
        const diff = (Date.now() - d.getTime()) / 1000;
        if (diff < 3600) return `há ${Math.max(1, Math.round(diff / 60))} min`;
        if (diff < 86400) return `há ${Math.round(diff / 3600)} h`;
        return `há ${Math.round(diff / 86400)} d`;
};

export const ArticleRow = ({ article, index = 0, compact = false }) => {
        const ref = String(index + 1).padStart(3, "0");
        return (
                <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group block border-b border-[var(--line)] py-5 hover:bg-[var(--paper)] px-3 -mx-3 transition-colors"
                >
                        <div className="flex items-start gap-4">
                                <span className="line-no flex-shrink-0 pt-1">{ref}</span>
                                <div className="flex-1 min-w-0">
                                        <div className="flex flex-wrap items-center gap-3 mb-2">
                                                <span
                                                        className="overline"
                                                        style={{ color: "var(--ai)" }}
                                                >
                                                        {article.outlet}
                                                </span>
                                                <span className="overline text-[var(--ink-faint)]">
                                                        {timeAgo(article.published_at)}
                                                </span>
                                                {article.matched_parties?.slice(0, 3).map((p) => (
                                                        <span
                                                                key={p}
                                                                className="overline px-2 py-[2px] border border-[var(--line-strong)] text-[var(--controversy)]"
                                                        >
                                                                {p}
                                                        </span>
                                                ))}
                                                {article.matched_movements?.slice(0, 2).map((m) => (
                                                        <span
                                                                key={m}
                                                                className="overline px-2 py-[2px] border border-[var(--line-strong)] text-[var(--truth)]"
                                                        >
                                                                {m}
                                                        </span>
                                                ))}
                                        </div>
                                        <h3 className="font-serif text-xl md:text-2xl leading-tight text-[var(--ink)] group-hover:text-[var(--controversy)] transition-colors">
                                                {article.title}
                                        </h3>
                                        {!compact && article.summary && (
                                                <p className="text-[13px] leading-relaxed text-[var(--ink-soft)] mt-2 line-clamp-2 font-mono">
                                                        {article.summary}
                                                </p>
                                        )}
                                </div>
                                <ExternalLink
                                        size={14}
                                        strokeWidth={1.5}
                                        className="text-[var(--ink-faint)] group-hover:text-[var(--controversy)] mt-2"
                                />
                        </div>
                </a>
        );
};

export default ArticleRow;
